import Service from 'src/setup/network';
import { Dispatch } from 'redux';
import {
  FETCH_LABEL_FAILURE,
  FETCH_LABEL_REQUEST,
  FETCH_LABEL_SUCCESS,
  LabelActionType,
} from '../types/labelType';

export const fetchLabelRequest = (): LabelActionType => ({
  type: FETCH_LABEL_REQUEST,
});

export const fetchLabelSuccess = (data: any): LabelActionType => ({
  type: FETCH_LABEL_SUCCESS,
  payload: data,
});

export const fetchLabelFailure = (error: string): LabelActionType => ({
  type: FETCH_LABEL_FAILURE,
  payload: error,
});

export const fetchLabel = () => {
  return async (dispatch: Dispatch<LabelActionType>) => {
    dispatch(fetchLabelRequest());
    try {
      const request = await Service.get('/labels');
      const data: any = request?.data;
      dispatch(fetchLabelSuccess(data));
    } catch (error: any) {
      dispatch(fetchLabelFailure(error?.response?.data?.message));
      throw new Error('Failed to fetch customer');
    }
  };
};
